import React, { useEffect, useState } from 'react';
import {Col, Container, Row, Card, CardBody, NavItem, NavLink, Nav, TabPane, Button, TabContent} from 'reactstrap';
import { Link, useParams } from 'react-router-dom'
import axios from 'axios'
import classnames from "classnames";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import ProgramsCard from './View/ProgramsCard'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { isEmpty } from '@/shared/helpers'
import ViewUserProfile from "./View/profile";
import ViewUserHistory from "./View/history";
import ViewUserGiftCodesRedeemed from "./View/giftCodesRedeemed";
import ViewUserChangeLogs from "./View/changeLogs";
import { fetchRoles, fetchUserPrograms, fetchUserProgramRoles } from "@/shared/apiHelper"
import {login} from "../App/auth";
import ReclaimPoints from './View/ReclaimPoints';
import UserAddresses from './View/UserAddresses';
import {useDispatch,flashSuccess, sendFlashMessage} from "@/shared/components/flash"
import ApiErrorMessage from "@/shared/components/ApiErrorMessage"
const queryClient = new QueryClient()

const ViewUser = ({ organization }) => {

    const [userPrograms, setUserPrograms] = useState(null)
    const [userProgramAccountHolderIds, setUserProgramAccountHolderIds] = useState(null);
    const [userProgramIds, setUserProgramIds] = useState(null)
    let { id } = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    // Tabs Panel
    const [currentActiveTab, setCurrentActiveTab] = useState('1');
    const togglePan = tab => {
        if (currentActiveTab !== tab) setCurrentActiveTab(tab);
    }
    const fetchUser = async (id) => {
        try {
            const response = await axios.get(`/organization/${organization.id}/user/${id}`);
            await fetchUserPrograms( organization.id, id )
                .then( data => {
                    console.log(data, 'USER data')
                    setUserPrograms(data);
                    setUserProgramAccountHolderIds(data.map(a => a.account_holder_id));
                    setUserProgramIds(data.map(a => a.id));
                })

            return response.data;
        } catch (e) {
            throw new Error(`API error:${e?.message}`);
        }
    };

    const { isLoading, error, data, isSuccess, remove } = useQuery(
        ['userGlobalInfo', id],
        () => fetchUser(id),
        {
            keepPreviousData: false,
            staleTime: Infinity,
        }
    )
     const handleAddAddress = (data) => {
        if(id !==false && id !=='undefined') { 
            axios
            .post(`/users/${id}/addresses`, data)
            .then((res) => {
                if (res.status === 200) {
                flashSuccess(dispatch,
                    "User Address Added successfully!"
                );
                //toggle();
                setLoading(false);
                }
            })
            .catch((error) => {
                // return false;
                if (error?.response?.data) {
                dispatch(
                    sendFlashMessage(
                    <ApiErrorMessage errors={error.response.data} />,
                    "alert-danger"
                    )
                );
                setLoading(false);
                }
            });
        }
    };

    const handleEditAddress = (address) => {
        if(id !==false && id !=='undefined') { 
            axios
            .put(`/users/${id}/addresses/${address?.id}`, address)
            .then((res) => {
                if (res.status === 200) {
                flashSuccess(dispatch, "Address Updated successfully!")
                //toggle();
                setLoading(false);
                }
            })
            .catch((error) => {
                // return false;
                if (error?.response?.data) {
                dispatch(
                    sendFlashMessage(
                    <ApiErrorMessage errors={error.response.data} />,
                    "alert-danger"
                    )
                );
                setLoading(false);
                }
            });
        }
    };
    const handleDeleteAddress = (address_id) => {
        if(id !==false && id !=='undefined' && address_id) {  
            axios
            .delete(`/users/${id}/addresses/${address_id}`)
            .then((res) => {
                if (res.status === 200) {
                   flashSuccess(dispatch,
                    "Address Deleted successfully!"
                    );
                //toggle();
                setLoading(false);
                }
            })
            .catch((error) => {
                // return false;
                if (error?.response?.data) {
                dispatch(
                    sendFlashMessage(
                    <ApiErrorMessage errors={error.response.data} />,
                    "alert-danger"
                    )
                );
                setLoading(false);
                }
            });
        }
    };
    if (error) {
        return <p>Error loading user</p>;
    }
    if (isLoading) {
        return <p>Loading...</p>;
    }
    if (isSuccess) {
        const fullName = `${data.first_name} ${data.last_name}`
        return (
            <Container className="dashboard">
                <Row>
                    <Col md={12}>
                        <h3 className="page-title">{fullName}</h3>
                        <h3 className="page-subhead subhead"><Link className="" to="/">Home</Link> / <Link className="" to="/users">Users</Link> / {fullName}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Card>
                            <CardBody className='infoview'>
                               <Col md={12} style={{textAlign:"right"}}><a href={`/users/edit/${data.id}`} className="link a" >Edit</a></Col>
                                <Row>
                                
                                    <Col md="8" >
                                        <Nav tabs>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({
                                                        active:
                                                            currentActiveTab === '1'
                                                    })}
                                                    onClick={() => {
                                                        togglePan('1');
                                                    }}
                                                >
                                                    User Profile
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({
                                                        active:
                                                            currentActiveTab === '2'
                                                    })}
                                                    onClick={() => {
                                                        togglePan('2');
                                                    }}
                                                >
                                                    History
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({
                                                        active:
                                                            currentActiveTab === '3'
                                                    })}
                                                    onClick={() => {
                                                        togglePan('3');
                                                    }}
                                                >
                                                    Gift Codes Redeemed
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({
                                                        active:
                                                            currentActiveTab === '4'
                                                    })}
                                                    onClick={() => {
                                                        togglePan('4');
                                                    }}
                                                >
                                                    Change Logs
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({
                                                        active:
                                                            currentActiveTab === '5'
                                                    })}
                                                    onClick={() => {
                                                        togglePan('5');
                                                    }}
                                                >
                                                    Reclaim Points
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({
                                                        active:
                                                            currentActiveTab === '6'
                                                    })}
                                                    onClick={() => {
                                                        togglePan('6');
                                                    }}
                                                >
                                                    User Addresses
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </Col>
                                </Row>
                                <TabContent activeTab={currentActiveTab} className="tabContent">
                                    <TabPane tabId="1" className="tabPane">
                                       {currentActiveTab !== "1" ? 'Loading...' : <ViewUserProfile programs={userProgramIds} data={data} organization={organization} />}
                                    </TabPane>
                                    <TabPane tabId="2" className="tabPane">
                                        {currentActiveTab !== "2" ? 'Loading...' :<ViewUserHistory programs={userProgramAccountHolderIds} user={data} organization={organization} />}
                                    </TabPane>
                                    <TabPane tabId="3" className="tabPane">
                                        {currentActiveTab !== "3" ? 'Loading...' : <ViewUserGiftCodesRedeemed programs={userProgramAccountHolderIds} user={data} organization={organization} />}
                                    </TabPane>
                                    <TabPane tabId="4" className="tabPane">
                                       { currentActiveTab !== "4" ? 'Loading...' : <ViewUserChangeLogs programs={userProgramAccountHolderIds} user={data} organization={organization} />}
                                    </TabPane>
                                    <TabPane tabId="5" className="tabPane">
                                        { currentActiveTab !== "5" ? 'Loading...' : <ReclaimPoints programs={userProgramAccountHolderIds} user={data} organization={organization} userPrograms={userPrograms} />}
                                    </TabPane>
                                    <TabPane tabId="6" className="tabPane">
                                        { currentActiveTab != 6 ? 'Loading...' : <UserAddresses addresses={data?.addresses} onAdd={handleAddAddress} onEdit={handleEditAddress} onDelete={handleDeleteAddress} 
                                        userId={data.id} /> }
                                    </TabPane>
                                </TabContent>

                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <ProgramsCard user={data} />
                    </Col>
                </Row>
            </Container>
        )
    }
}

const Wrapper = ({ organization }) => {
    return (
        <QueryClientProvider client={queryClient}>
            {!isEmpty(organization) && <ViewUser organization={organization} />}
        </QueryClientProvider>
    )
}

export default withRouter(connect((state) => ({
    organization: state.organization
}))(Wrapper));

// export default Wrapper;


